export const parseUserInfo = (response) => {
    let data
    
    if (response?.error?.data) {
        data = response.error.data.split('||JasonEnd')[0].trim()
    } else {
        data = response.split('||JasonEnd')[0].trim()
    }
    
    try {
        const parsedData = JSON.parse(data)
        return parsedData;
    } catch (error) {
        console.error('Failed to parse user info:', error)
        return null
    }
}
